import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges, Renderer2, Signal, SimpleChanges, computed } from '@angular/core';

import { IPlayerChapter } from './chapters/IPlayerChapter';
import { IScrubAdapter } from './scrubAdapter/IScrubAdapter';

@Component({
	selector: 'vb-scrub-bar-chapter',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
		<vb-scrub-bar-progress
			[progressPercentage]="progressWidthSignal()">
		</vb-scrub-bar-progress>
	`,
	host: {
		'[style.width]': 'chapterWidth',
		'[style.left.%]': 'chapterLeftPosition',
		'[style.margin-right]': "isLast ? '' : chapterSpacing"
	},
	standalone: false,
	styleUrls: ['./VbScrubBarChapter.Component.ng.less']
})
export class VbScrubBarChapterComponent implements OnChanges, AfterViewInit {
	@Input() public chapter: IPlayerChapter;
	@Input() public nextChapter: IPlayerChapter;
	@Input() public adapter: IScrubAdapter;
	@Input() public isLast: boolean;

	public readonly chapterSpacing = '2px';

	public chapterWidth: string;
	public chapterLeftPosition: number;

	public progressWidthSignal: Signal<string> = computed(() => {
		const chapterEndTime = this.nextChapter ? this.nextChapter.time : this.adapter.getDuration();
		const isPastChapterEnd = this.adapter.getCurrentTime() >= chapterEndTime;
		const isWithinChapter = this.adapter.getCurrentTime() > this.chapter.time;
		const progressPercentage = ((this.adapter.getCurrentTime() - this.chapter.time) / (chapterEndTime - this.chapter.time)) * 100;

		if (isPastChapterEnd) {
			return '100%';
		} else if (isWithinChapter) {
			return `${progressPercentage}%`;
		}
		return '0%';

	});

	constructor(
		private el: ElementRef,
		private renderer: Renderer2
	) { }

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.chapter || changes.nextChapter) {
			this.setCalculatedStyles();
		}
	}

	public ngAfterViewInit(): void {
		const computedStyle = window.getComputedStyle(this.el.nativeElement);
		const width = computedStyle.width;

		if (parseFloat(width) === 0) {
			this.renderer.setStyle(this.el.nativeElement, 'margin-right', '0');
		}
	}

	private setCalculatedStyles(): void {
		this.chapterWidth = this.calculateChapterWidth();
		this.chapterLeftPosition = this.calculateChapterLeftPosition();
	}

	private calculateChapterWidth(): string {
		const chapterEndTime = this.nextChapter ? this.nextChapter.time : this.adapter.getDuration();
		const chapterDuration = chapterEndTime - this.chapter.time;
		const widthPercentage = (chapterDuration / this.adapter.getDuration()) * 100;
		const extraBuffer = '1px'; // subtract extra to prevent rounding errors
		return this.nextChapter ? `calc(${widthPercentage.toString()}% - ${this.chapterSpacing} - ${extraBuffer})` : `${widthPercentage.toString()}%`;
	}

	private calculateChapterLeftPosition(): number {
		const chapterStartTime = this.chapter.time;
		const leftPercentage = (chapterStartTime / this.adapter.getDuration()) * 100;
		return leftPercentage;
	}

}
